<!-- table buttons and search result total -->
<div class="tw-flex tw-flex-wrap tw-gap-4 tw-mb-3 tw-mt-5">
  <button
    mat-raised-button
    [class.spinner]="refreshing"
    [disabled]="refreshing"
    (click)="refreshData()"
    class="tw-shrink-0">
    Refresh
  </button>
  <button
    [disabled]="viewCount == 0"
    mat-raised-button
    color="primary"
    (click)="downloadData()"
    class="tw-shrink-0 tw-mr-4">
    Download
  </button>
  <div class="count tw-flex tw-items-center">
    <mat-progress-spinner
      mode="indeterminate"
      class="tw-mr-3"
      diameter="20"
      *ngIf="countUpdating; else contactCount">
    </mat-progress-spinner>
    <ng-template #contactCount>
      <span class="tw-mr-2 tw-font-semibold">{{viewCount | number}}</span>
    </ng-template>
    Matching People
  </div>
</div>

<!-- table -->
<div class="container tw-px-0">
  <div class="tw-max-w-[60rem]" *ngIf="peopleGridType === 'sample'">
    <app-alert
      *ngIf="!readOnly"
      [alertType]="AlertType.Info"
      [alertStyle]="'compact'"
      [hasBorder]="false"
      [noBottomMargin]="true"
      [closeable]="true">
      <p class="tw-my-0 tw-text-sm">
        Preview data below includes
        <span class="tw-font-semibold"> limited columns and rows. </span>
        Download the data for the full dataset.
      </p>
    </app-alert>
  </div>
  <ag-grid-angular
    style="height: 100%; width: 100%"
    [ngClass]="{ 'ag-theme-balham': !(darkModeService.darkMode$ | async), 'ag-theme-balham-dark': darkModeService.darkMode$ | async }"
    [rowData]="rowData"
    [tooltipShowDelay]="tooltipShowDelay"
    [columnDefs]="columnDefs"
    [rowModelType]="rowModelType"
    [cacheBlockSize]="cacheBlockSize"
    [defaultColDef]="defaultColDef"
    (gridReady)="onGridReady($event)"
    [sideBar]="sideBar"
    [getRowId]="getRowId"
    enableCellTextSelection="true"
    [serverSideDatasource]="serverSideDatasource"
    (displayedColumnsChanged)="saveColumnState()">
  </ag-grid-angular>
</div>
